module.exports = __webpack_public_path__ + "img/messenger.cd907d19.png";